import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8d14942"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8d14942')) {
      api.createRecord('b8d14942', component.options)
    } else {
      api.reload('b8d14942', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b8d14942", function () {
      api.rerender('b8d14942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/directToViewEvaluations/index.vue"
export default component.exports